import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip, Input, Badge, Button } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/cpnsService";

import DataTableBloc from "../Blocs/DataTableBloc";
import IndexBloc from "../Blocs/IndexBloc";
import apiResponse from "../../../../../services/apiResponse";

import moment from "moment";

class TableSecondaryComponent extends Component {
  dataTableBloc = new DataTableBloc();
  indexBloc = new IndexBloc();
  queryParams = new URLSearchParams(window.location.search);

  source;
  historyTable = "PNSTableSecondaryActive";
  defaultOrder = "cpns_id";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  modal_confirm_status = 0;
  modal_confirm_message = "";
  modal_confirm_sucess_message = "data berhasil di nonaktifkan";
  modal_confirm_error_message = "data gagal di nonaktifkan";

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      approveUuid: null,
      inactiveUuid: null,
      uploadSkUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
      col1: true,
      col2: false,
      dataSelected: [],
      checkAll: false,
      periodUuid: this.queryParams.get("uuid"),
    };
  }

  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  dateParse = (input) => {
    let res = "";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  dateParseId = (input) => {
    let res = "";
    if (input != "" && input != null) {
      res = moment(input).locale("id-id").format("DD MMMM YYYY");
    }
    return res;
  };

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }

    const userdata = JSON.parse(localStorage.getItem('userdata'))

    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      pns_status: 1,
      period_uuid: this.state.periodUuid,
      role_id: localStorage.getItem("currentRoleId"),
    };
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };

  handleDownloadDraftSK = (uuid) => {
    this.indexBloc.fetchDownloadDraftSK({
      cpns_uuid: uuid,
    });
  };

  handleChecked = (e, uuid) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({
        dataSelected: [...this.state.dataSelected, uuid],
      });
    } else {
      var filteredAry = this.state.dataSelected.filter((e) => e !== uuid);
      this.setState({
        dataSelected: filteredAry,
      });
    }
    console.log(uuid, checked);
  };

  handleButtonProcess = () => {
    console.log(this.state.dataSelected);
    this.modal_confirm_message =
      "Apakah anda yakin akan memproses data terpilih?";
    this.modal_confirm_status = 1;
    this.setState({
      confirm: true,
    });
  };

  handleCheckAll = (e) => {
    let checked = e.target.checked;
    let uuidSelected = [];
    for (let i = 0; i < this.state.rows.length; i++) {
      let thisId = this.state.rows[i].cpns_id;
      let thisUuid = this.state.rows[i].cpns_uuid;
      this.setState({
        [`check${thisId}`]: !this.state.checkAll,
      });
      if (checked == true) {
        uuidSelected[i] = thisUuid;
      }
    }

    this.setState({
      checkAll: !this.state.checkAll,
      dataSelected: uuidSelected,
    });
  };

  resetTable = () => {
    this.setState({
      dataSelected: [],
    });
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        let data_status = parseInt(this.modal_confirm_status);
        if (data_status === 1) {
          this.inactiveData();
        } else {
          //this.activeData()
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;

          // set state for every checkbox
          for (let i = 0; i < response.result.length; i++) {
            let thisId = response.result[i].cpns_id;
            this.setState({
              [`check${thisId}`]: false,
            });
          }
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          //this.props.totalCandidate(response.total)
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.downloadDraftSKChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          //window.location.href = link.file_url
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel?.unsubscribe();
    this.indexBloc.downloadDraftSKChannel?.unsubscribe();
  }

  columns = [
    //   {
    //     key: "cpns_id",
    //     text: "Pilih",
    //     className: "cpns_id",
    //     sortable: false,
    //     header: () => {
    //       return (
    //         <div className="form-check text-center font-size-16">
    //           <Input
    //             className="form-check-input"
    //             type="checkbox"
    //             name="checkAll"
    //             value=""
    //             checked={this.state.checkAll}
    //             onChange={(event) => {
    //               this.handleCheckAll(event)
    //             }}
    //           />
    //         </div>
    //       )
    //     },
    //     cell : record => {
    //         const thisId = record.cpns_id
    //         return (
    //         <div className="form-check text-center font-size-16">
    //           <Input
    //             type="checkbox"
    //             className="form-check-input"
    //             id={'checkbox' + thisId }
    //             onChange={
    //               (event)=>{
    //                   this.handleChecked(event, record.cpns_uuid)
    //                   this.setState({
    //                       [`check${thisId}`] : !this.state[`check${thisId}`]
    //                   })
    //               }
    //             }
    //             checked={this.state[`check${thisId}`]}
    //           />
    //         </div>
    //       )
    //     }
    // },
    {
      key: "cpns_bkn_confirmation_number",
      text: "",
      className: "cpns_bkn_confirmation_number",
      sortable: true,
      header: () => {
        return (
          <div className="text-center">
            Penetapan NIP BKN <br />
            Nomor <br />
            Tanggal
          </div>
        );
      },
      cell: (record) => {
        return (
          <div>
            {record.cpns_bkn_confirmation_number}
            <br />
            {this.dateParseId(record.cpns_bkn_confirmation_date)}
          </div>
        );
      },
    },
    {
      key: "cpns_candidate_full_name",
      text: "",
      className: "cpns_candidate_full_name",
      sortable: true,
      header: () => {
        return (
          <div className="text-center">
            Nama <br />
            NIP <br />
            Tempat, Tanggal Lahir
          </div>
        );
      },
      cell: (record) => {
        return (
          <div>
            {record.cpns_candidate_full_name}
            <br />
            {`${record.cpns_candidate_nip}`}
            <br />
            {`${
              record.cpns_candidate_place_of_birth_city_name != null
                ? record.cpns_candidate_place_of_birth_city_name
                : record.cpns_candidate_place_of_birth_city_text
            }, ${this.dateParseId(record.cpns_candidate_date_of_birth)}`}
          </div>
        );
      },
    },
    {
      key: "cpns_candidate_gender_name",
      text: "Jenis Kelamin",
      className: "cpns_candidate_gender_name",
      sortable: true,
    },
    {
      key: "cpns_candidate_last_education_name",
      text: "Pendidikan Tertinggi",
      className: "cpns_candidate_last_education_name",
      sortable: true,
      cell: (record) => {
        return (
          <div className="text-center">
            {record.cpns_candidate_last_education_name}
            <br />
            {record.cpns_candidate_last_education_major}
          </div>
        );
      },
    },
    {
      key: "cpns_candidate_last_education_name",
      text: "Pangkat",
      className: "cpns_candidate_last_education_name",
      sortable: true,
      cell: (record) => {
        return (
          <div className="text-center">
            {`${record.cpns_candidate_rank_name} (${record.cpns_candidate_rank_group_room})`}
          </div>
        );
      },
    },
    {
      key: "jabatan_pada_unit_kerja",
      text: "",
      className: "jabatan_pada_unit_kerja",
      sortable: true,
      header: () => {
        return (
          <div className="text-center">
            Jabatan Pada <br />
            Unit Kerja
          </div>
        );
      },
    },
    {
      key: "cpns_pns_status_name",
      text: "Status",
      className: "cpns_pns_status_name",
      sortable: true,
      width: "100",
      cell: (record) => {
        return (
          <label
            className={`badge rounded-pill ${record.cpns_pns_status_class} font-size-12`}
          >
            {record.cpns_pns_status_submit_name}
          </label>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.cpns_id;
        var status = record.cpns_pns_status_submit;
        var role =   localStorage.getItem("currentRoleId");
       
        return (
          <Fragment>
            {/* {status == 1 ? ( */}
            <span>
              <button
                className="btn btn-primary btn-sm"
                id={"detail-" + thisId}
                onClick={() => {
                  this.setState({
                    detailUuid: record.cpns_uuid,
                  });
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-file-search-alt"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["detail" + thisId]}
                target={"detail-" + thisId}
                toggle={() => {
                  this.setState({
                    ["detail" + thisId]: !this.state["detail" + thisId],
                  });
                }}
              >
                Detail PNS
              </Tooltip>
            </span>
            {status == 0 && role == 2  ? (
              <span>
                <button
                  className="btn btn-warning btn-sm"
                  id={"uploadSk-" + thisId}
                  onClick={() => {
                    this.setState({
                      uploadSkUuid: record.cpns_uuid,
                    });
                  }}
                  style={{
                    marginRight: "2px",
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-file-upload-alt"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["uploadSk" + thisId]}
                  target={"uploadSk-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["uploadSk" + thisId]: !this.state["uploadSk" + thisId],
                    });
                  }}
                >
                  Upload File PRAJAB & MCU
                </Tooltip>
              </span>
            ) : (
              ""
            )}
             {/* {status == 1 && role == 1  ? (
              <span>
              <button
                className="btn btn-danger btn-sm"
                id={"approve-" + thisId}
                onClick={() => {
                  this.setState({
                    approveUuid: record.cpns_uuid,
                  });
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-file-search-alt"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["approve" + thisId]}
                target={"approve-" + thisId}
                toggle={() => {
                  this.setState({
                    ["approve" + thisId]: !this.state["approve" + thisId],
                  });
                }}
              >
                Approve
              </Tooltip>
            </span>
            ) : (
              ""
            )} */}
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <>
        {/* <b>
                  Data Terpilih : <Badge className="rounded-pill bg-success font-size-12"> {this.state.dataSelected.length} </Badge> dari total <Badge className="rounded-pill bg-warning font-size-12"> {this.state.totalRow} </Badge>
                </b>
                &nbsp;&nbsp;&nbsp;&nbsp;
                {
                    (accessRole('create')) ?
                        <Button 
                          color="primary"
                          onClick={
                            () => {
                              this.handleButtonProcess()
                            }
                          }
                          disabled={this.state.dataSelected.length > 0 ? false : true}
                        >Proses Data Terpilih</Button>
                    : null
                } */}

        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={this.modal_confirm_message}
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo={this.modal_confirm_sucess_message}
          failedTitle="Gagal!"
          failedInfo={this.modal_confirm_error_message}
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.detailUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/dokumen_pns.html?detail_pns&uuid=" +
              this.state.detailUuid
            }
          />
        ) : null}
        {this.state.uploadSkUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/dokumen_pns.html?upload_sk&uuid=" +
              this.state.uploadSkUuid
            }
          />
        ) : null}
         {this.state.approveUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/dokumen_pns.html?approve&uuid=" +
              this.state.approveUuid 
            }
          />
        ) : null}
      </>
    );
  }
}

export default TableSecondaryComponent;
